/*global AmCharts, App */

Components.Energy.Engineer.VawCompare = function (container, loadDataLink) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var _colors = App.Ui.getColors();
    var _stocks = [
        {title: "Napětí", unit: "V", valueField: "voltage"},
        {title: "Proud", unit: "A", valueField: "current"},
        {title: "Činný výkon", unit: "W", valueField: "powerActive"},
        {title: "Jalový výkon", unit: "Var", valueField: "powerReactive"}
    ];
    var zoomedEvent = function (event) {
        for (var s in _chart.dataSets) {
            var set = _chart.dataSets[s];
            var voltage = {sum: 0, count: 0}, current = {sum: 0, count: 0}, powerActive = {sum: 0, count: 0}, powerReactive = {sum: 0, count: 0};
            for (var p in set.dataProvider) {
                var record = set.dataProvider[p];
                if (record.date.getTime() < event.startDate.getTime() || record.date.getTime() > event.endDate.getTime())
                    continue;

                if (!voltage.min)
                    voltage.min = record.voltage;
                if (!voltage.max)
                    voltage.max = record.voltage;
                if (record.voltage < voltage.min)
                    voltage.min = record.voltage;
                if (record.voltage > voltage.max)
                    voltage.max = record.voltage;
                voltage.sum = voltage.sum + record.voltage;
                voltage.count++;

                if (!current.min)
                    current.min = record.current;
                if (!current.max)
                    current.max = record.current;
                if (record.current < current.min)
                    current.min = record.current;
                if (record.current > current.max)
                    current.max = record.current;
                current.sum = current.sum + record.current;
                current.count++;

                if (!powerActive.min)
                    powerActive.min = record.powerActive;
                if (!powerActive.max)
                    powerActive.max = record.powerActive;
                if (record.powerActive < powerActive.min)
                    powerActive.min = record.powerActive;
                if (record.powerActive > powerActive.max)
                    powerActive.max = record.powerActive;
                powerActive.sum = powerActive.sum + record.powerActive;
                powerActive.count++;

                if (!powerReactive.min)
                    powerReactive.min = record.powerReactive;
                if (!powerReactive.max)
                    powerReactive.max = record.powerReactive;
                if (record.powerReactive < powerReactive.min)
                    powerReactive.min = record.powerReactive;
                if (record.powerReactive > powerReactive.max)
                    powerReactive.max = record.powerReactive;
                powerReactive.sum = powerReactive.sum + record.powerReactive;
                powerReactive.count++;
            }
            voltage.avg = (voltage.sum / voltage.count).toFixed(1);
            current.avg = (current.sum / current.count).toFixed(1);
            powerActive.avg = (powerActive.sum / powerActive.count).toFixed(1);
            powerReactive.avg = (powerReactive.sum / powerReactive.count).toFixed(1);
            $("#vaw-table-" + s + " td:nth-child(3)").text(voltage.min);
            $("#vaw-table-" + s + " td:nth-child(4)").text(voltage.max);
            $("#vaw-table-" + s + " td:nth-child(5)").text(voltage.avg);
            $("#vaw-table-" + s + " td:nth-child(6)").text(current.min);
            $("#vaw-table-" + s + " td:nth-child(7)").text(current.max);
            $("#vaw-table-" + s + " td:nth-child(8)").text(current.avg);
            $("#vaw-table-" + s + " td:nth-child(9)").text(powerActive.min);
            $("#vaw-table-" + s + " td:nth-child(10)").text(powerActive.max);
            $("#vaw-table-" + s + " td:nth-child(11)").text(powerActive.avg);
            $("#vaw-table-" + s + " td:nth-child(12)").text(powerReactive.min);
            $("#vaw-table-" + s + " td:nth-child(13)").text(powerReactive.max);
            $("#vaw-table-" + s + " td:nth-child(14)").text(powerReactive.avg);
        }
    };
    var createChart = function () {
        _chart = new AmCharts.AmStockChart();
        _chart.language = "cz";
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;

        for (var i in _stocks) {
            i = parseInt(i);
            var stock = _stocks[i];
            var stockPanel = new AmCharts.StockPanel();
            stockPanel.title = stock.title;
            stockPanel.showCategoryAxis = i === _stocks.length - 1 ? true : false;
            stockPanel.percentHeight = 25;
            stockPanel.recalculateToPercents = "never";
            stockPanel.usePrefixes = true;
            stockPanel.stockLegend = {
                valueTextRegular: "[[value]]" + stock.unit,
                periodValueTextComparing: "[[value]]" + stock.unit
            };

            var graph = new AmCharts.StockGraph();
            graph.id = "g1";
            graph.valueField = stock.valueField;
            graph.type = "line";
            graph.lineThickness = 1.5;
            graph.comparable = true;
            graph.compareField = stock.valueField;
            graph.compareGraphType = "line";
            graph.compareGraphLineThickness = 1.5;
            stockPanel.addStockGraph(graph);

            var valueAxis = new AmCharts.ValueAxis();
            valueAxis.unit = stock.unit;
            stockPanel.addValueAxis(valueAxis);

            _chart.addPanel(stockPanel);
        }

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 60;
        panelsSettings.marginBottom = 5;
        _chart.panelsSettings = panelsSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        _chart.valueAxesSettings = valueAxesSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["5mm", "15mm", "hh", "6hh", "12hh", "DD", "MM", "YYYY"];
        categoryAxesSettings.minPeriod = "5mm";
        _chart.categoryAxesSettings = categoryAxesSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = false;
        _chart.chartCursorSettings = cursorSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.enabled = true;
        scrollbarSettings.graph = "g1";
        scrollbarSettings.position = "bottom";
        scrollbarSettings.updateOnReleaseOnly = true;
        scrollbarSettings.usePeriod = "5mm";
        _chart.chartScrollbarSettings = scrollbarSettings;

        _chart.addListener("zoomed", zoomedEvent);
        _chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        _chart.write(container);
        loadData();
    };
    var refreshChart = function () {
        _chart.validateData();
    };
    var prepareData = function (rawData) {
        for (var i in rawData) {
            var set = rawData[i];
            var dataSet = new AmCharts.DataSet();
            dataSet.title = set.name;
            dataSet.color = _colors[i];
            dataSet.fieldMappings = [
                {fromField: "voltage", toField: "voltage"},
                {fromField: "current", toField: "current"},
                {fromField: "powerActive", toField: "powerActive"},
                {fromField: "powerReactive", toField: "powerReactive"}
            ];
            dataSet.dataProvider = [];
            dataSet.compared = i === 0 ? false : true;
            dataSet.categoryField = "date";
            _chart.dataSets.push(dataSet);
        }

        for (var i in rawData) {
            var set = rawData[i];
            var dataProvider = [];
            for (var index in set.records) {
                var record = set.records[index];
                if (record.voltage === null)
                    continue;
                var date = new Date(record.timestamp * 1000);
                dataProvider.push({
                    date: date,
                    voltage: record.voltage,
                    current: record.current,
                    powerActive: record.powerActive,
                    powerReactive: record.powerReactive
                });
            }
            _chart.dataSets[i].dataProvider = dataProvider;
        }
        refreshChart();
    };
    var loadData = function () {
        App.Ui.widgetBlock($("#" + container));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            type: "post",
            complete: function () {
                App.Ui.widgetBlock($("#" + container), "stop");
            },
            success: function (result) {
                if (result.dataSets === null || result.dataSets.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    prepareData(result.dataSets);
                }
            },
            error: function () {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var zoomToHour = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        $(this).blur();
    };
    var zoomToDay = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        $(this).blur();
    };
    var zoomMax = function () {
        zoomOut();
        $(this).blur();
    };
    /* public */
    /* construct */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
